export const INVALID_TOKEN = 401;
export const NOT_ALLOWED = 403;
export const FEATURE_NOT_AVAILABLE = 'feature_not_available';

// 408 Request Timeout and 429 Too Many Requests are the only 4xx codes worth retrying;
// every 5xx (500-599) is a server-side failure and is retryable too.
export const RETRYABLE_STATUS_CODES = [408, 429];

export interface IRetryableError {
  code?: string;
  response?: { status?: number };
}

// A client-side timeout (no `response`), a 5xx, or one of RETRYABLE_STATUS_CODES is worth
// retrying; any other 4xx means the request itself is wrong and retrying won't help.
export const isRetryableError = (error: IRetryableError): boolean => {
  if (error?.code === 'ECONNABORTED') return true;
  if (!error?.response) return true;
  const status = error.response.status;
  return RETRYABLE_STATUS_CODES.includes(status) || (typeof status === 'number' && status >= 500);
};

// Actions resolve with an Error instead of rejecting, which a poller would read as a success.
// Unwrap before handing the result to one, or backoff and the circuit breaker never engage.
export const unwrapActionResult = <T>(result: T | Error | null | undefined, context: string): T => {
  if (result instanceof Error) throw result;
  if (result == null) throw new Error(`${context}: empty response`);
  return result;
};
